import React from 'react';
import PostScreenComponent from './PostScreen.component';

const PostScreenContainer = props => {
  const companyId = props.match.params.id;
  return <PostScreenComponent companyId={companyId} {...props} />;
};

export default PostScreenContainer;
